//src/styles/components/MuiButton.js
import palette from "../palette";
import shape from "../shape";

const MuiButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: shape.borderRadius,
      padding: theme.spacing(1.5, 3.5), // 12px 28px
      fontWeight: theme.typography.fontWeightMedium,
      transition: theme.custom.transitions.default,
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: `0 4px 8px ${palette.raw.border}`,
      },
    }),
    containedPrimary: ({ theme }) => ({
      backgroundColor: palette.primary.main,
      color: palette.primary.contrastText,
      "&:hover": {
        backgroundColor: palette.primary.dark,
        boxShadow: `0 6px 12px ${palette.primary.alpha['30']}`,
      },
    }),
    containedSecondary: ({ theme }) => ({
      backgroundColor: palette.secondary.main,
      color: palette.secondary.contrastText,
      "&:hover": {
        backgroundColor: palette.secondary.dark,
        boxShadow: `0 6px 12px ${palette.secondary.alpha['30']}`,
      },
    }),
    outlinedPrimary: ({ theme }) => ({
      borderColor: palette.primary.main,
      color: palette.primary.main,
      "&:hover": {
        backgroundColor: palette.primary.alpha['10'],
        borderColor: palette.primary.dark,
      },
    }),
    outlinedSecondary: ({ theme }) => ({
      borderColor: palette.secondary.main,
      color: palette.secondary.main,
      "&:hover": {
        backgroundColor: palette.secondary.alpha['10'],
        borderColor: palette.secondary.dark,
      },
    }),
    textPrimary: ({ theme }) => ({
      color: palette.primary.main,
      "&:hover": {
        backgroundColor: palette.primary.alpha['10'],
      },
    }),
    textSecondary: ({ theme }) => ({
      color: palette.secondary.main,
      "&:hover": {
        backgroundColor: palette.secondary.alpha['10'],
      },
    }),
  },
  defaultProps: {
    disableElevation: false,
  },
};

export default MuiButton;